import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-file-show-modal',
  templateUrl: './file-show-modal.component.html',
  styleUrls: ['./file-show-modal.component.scss']
})
export class FileShowModalComponent implements OnInit {
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  deleteIds:number[]=[];
  allItemIds: number[] = [];
  showLoader: boolean = false;
  selectedItems:boolean = false;
  test:boolean=true;
  base64File: string | null = null;
  base64FileName: string = '';
  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FileShowModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id?: any , name?: string, is_audit:any,voucherType?:any,creation_voucher_id?:any,isView?: boolean}
  ) {}

  ngOnInit(): void {
    this.showLoader = true; 
    const voucherId = this.data.id || this.data.creation_voucher_id;
     const voucherType = this.data?.voucherType;   
    // this.fetchImagesById(voucherId);
      this.fetchImagesById(voucherId, voucherType); 
  }
  // fetchImagesById(id: number) {
  //   this.allItemIds = [];
  //   this.apiService.getImagesById(id).subscribe(
  //     (data: any) => {
  //       data.imageUrls.forEach((imageUrl: any) => {
  //         if (this.isImage(imageUrl.extension)) {
  //           this.imageUrls.push(imageUrl);
  //           this.allItemIds.push(imageUrl.id);
  //         } else if (this.isDocument(imageUrl.extension)) {
  //           this.documentUrls.push(imageUrl);
  //           this.allItemIds.push(imageUrl.id);
  //         }
  //       });
  //     },
  //     error => {
  //       console.error('Error fetching images:', error);
  //     }
  //   );
  //   if(this.imageUrls.length==0){
  //     this.showLoader=false;
  //   }
  // }

 fetchImagesById(id: number, voucherType: number) {
  this.imageUrls = [];
  this.documentUrls = [];
  this.showLoader = true;

  this.apiService.getImagesById(id, voucherType).subscribe(
    (response: any) => {
      const files = response.imageUrls || [];
      files.forEach((file: any) => {
        file.selected = false;

          if (!file.url) {
            file.url = file.preview || (file.image ? `${this.apiService.hostURL}/storage/${file.image}` : file.url);
          }
          const extension = file.extension || (file.url ? file.url.split('.').pop() : '');

          if (this.isImage(extension)) {
            this.imageUrls.push(file);
          } else if (this.isDocument(extension)) {
            this.documentUrls.push(file);
          }
        });

      this.showLoader = false;
    },
    error => {
      console.error("Error fetching images:", error);
      this.showLoader = false;
    }
  );
}
  
  isImage(extension: string): boolean {
    const imageExtensions = ['jpeg', 'jpg', 'png', 'svg', 'gif','webp'];
    return imageExtensions.includes(extension.toLowerCase());
  }

  isDocument(extension: string): boolean {
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'];
    return documentExtensions.includes(extension.toLowerCase());
  }

openModal(): void {
  const modalRef = this.dialog.open(FileShowModalComponent, {
    width:'1200px',
    height:'600px',
    data: { id:this.data.id,name:this.test }
  });
}

  cancel(): void {
    this.dialogRef.close();
  }
  onCheckboxChange(id: number, type: 'image' | 'document') {
    console.log(`${type} with ID ${id} changed selection`);
  }

  hasSelectedItems(): boolean {
    return this.imageUrls.some(img => img.selected) || this.documentUrls.some(doc => doc.selected);
  }

  // deleteSelected() {
  //   this.imageUrls = this.imageUrls.filter(img => !img.selected);
  //   this.documentUrls = this.documentUrls.filter(doc => !doc.selected);
  // }

  deleteSelected() {
  if (!confirm("Are you sure you want to delete selected files?")) {
    return;
  }

  const itemsToDelete = [
    ...this.imageUrls.filter(img => img.selected),
    ...this.documentUrls.filter(doc => doc.selected)
  ];

  if (itemsToDelete.length === 0) return;
  itemsToDelete.forEach(item => {
    this.apiService.deleteVoucherPostingimage(item.id).subscribe(
      res => {
        console.log("Deleted:", item.id);
      },
      err => console.error("Delete failed:", err)
    );
  });
  this.imageUrls = this.imageUrls.filter(img => !img.selected);
  this.documentUrls = this.documentUrls.filter(doc => !doc.selected);

  alert("Selected files deleted successfully.");
}

  onFileSelected(event: any) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64Data = e.target.result.split(',')[1];
        this.imageUrls.push({
          id: file.id,
          name: file.name,
          url: e.target.result,
          selected: false,
          base64: base64Data,
          isNew: true 
        });
      };
      reader.readAsDataURL(file);
    }
  }

  saveFile(): void {
    const filesToPost = this.imageUrls.map(file => {
      if (file.isNew) {
        return {
          file_name: file.name,
          base64_data: file.base64
        };
      } else {
        return {
          file_name: file.name,
          base64_data: file.url
        };
      }
    });

    const payload = {
      creation_voucher_id: this.data.id,
      upload: filesToPost
    };

    console.log('Final Payload:', payload);
    this.apiService.auditUpload(payload).subscribe(
      response => {
        console.log('Upload complete:', response);
        window.location.reload();
      },
      error => {
        console.error('Upload failed:', error);
      }
    );
  }
}

